export { default } from './vacancies';
